import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSet } from "../InfoSets/InfoSet";
import { MacAddress } from "../Core/MacAddress";
import { IfEntry, IfTable } from "../InfoSets/IfTable";
import { Device } from "../Core/Device";
import { Dictionary } from "../Utils/Dictionary";
import { IpAddressTable, IpAddressEntry } from "../InfoSets/IpAddressTable";
import { PortLldpTable } from "../InfoSets/PortLldpTable";

export class MacAddressEntry {
	public MacAddress: MacAddress;

	public IfIndex: number;
	public IsIfUnique: boolean;

	// CACHE
	public IfEntry: IfEntry;
	public get HasIfEntry():boolean {
		return this.IfEntry != null;
	}

	public get HasUniqueIfEntry():boolean {
		if (this.HasIfEntry && this.IsIfUnique)
			return true;
		return false;
	}

	constructor(macAddress: MacAddress, ifIndex: number = -1) {
		this.MacAddress = macAddress;
		this.IfIndex = ifIndex;
		this.IsIfUnique = true;
		this.IfEntry = null;
	}
}

export class MacAddressTable extends InfoSet
{
	private _macTable: Dictionary<MacAddress, MacAddressEntry>;

	constructor(device: Device) {
		super(device);
		this._macTable = new Dictionary<MacAddress, MacAddressEntry>();
		return;
	}

	public Add(macAddress: MacAddress): MacAddressEntry {
		var macEntry: MacAddressEntry = null;

		if (macAddress != null) {
			macEntry = this._macTable.Item(macAddress);

			if(!macEntry) {
				macEntry = new MacAddressEntry(macAddress);
				this._macTable.Add(macAddress, macEntry);
			}
		}

		return macEntry;
	}

	public AddIpEntry(ipEntry: IpAddressEntry): MacAddressEntry {
		var macEntry: MacAddressEntry = null;

		if ((ipEntry != null) && ipEntry.HasMacAddress) {
			var macAddress: MacAddress = ipEntry.MacAddress;

			if (!macAddress.IsNull) {
				macEntry = this._macTable.Item(macAddress);
				if(!macEntry) {
					macEntry = new MacAddressEntry(macAddress, ipEntry.IfIndex);
					this._macTable.Add(macAddress, macEntry);
				}
			}
		}

		return macEntry;
	}

	public AddIfEntry(ifEntry: IfEntry): MacAddressEntry {
		var macEntry: MacAddressEntry = null;

		if ((ifEntry != null) && ifEntry.HasMacAddress) {
			var macAddress: MacAddress = ifEntry.MacAddress;

			if (!macAddress.IsNull) {
				macEntry = this._macTable.Item(macAddress);
				if(!macEntry) {
					macEntry = new MacAddressEntry(macAddress, ifEntry.IfIndex);
					this._macTable.Add(macAddress, macEntry);
				}
			}
		}

		return macEntry;
	}

	public Clear():void {
		this._macTable.Clear();
	}

	public get Count(): number {
		return this._macTable.Count;
	}

	public Find(macAddress: MacAddress):MacAddressEntry {
		return this._macTable.Item(macAddress);
	}

	public Remove(macEntry: MacAddressEntry ):boolean {
		return macEntry ? this. _macTable.Remove(macEntry.MacAddress):false;
	}

	private ClearIfEntryCache(): void {
		this._macTable.ForEach((pair) => {
			pair.Value.IfEntry = null;
		});
	}

	public RebuildIfEntryCache():void {
		// CLEAR the CACHE
		this.ClearIfEntryCache();

		if (this.Device == null)
			return;

		// NOTE: If the IF TABLE is empty; nothing to LOOKUP
		if (!this.Device.HasIfTable)
			return;

		var ifTable: IfTable = this.Device.IfTable;
		var ifEntry: IfEntry = null;

		this._macTable.ForEach((pair) => {
			if (pair.Value.IfIndex < 0)
				return;

			ifEntry = ifTable.Find(pair.Value.IfIndex);
			if (ifEntry == null)
				return;

			pair.Value.IfEntry = ifEntry;
		});
	}

	public Rebuild():void {
		this.Clear();

		if (Device == null)
			return;

		// REGISTER MAC ADDRESSES from IfEntry
		if (this.Device.HasIfTable) {
			this.RegisterIfTable(this.Device.IfTable);
		}

		// REGISTER any MAC ADDRESSES bound to an IP ADDRESS entry
		if (this.Device.HasIpAddressTable) {
			this.RegisterIpAddressTable(this.Device.IpAddressTable);
		}

		// REGISTER Dot1dBaseBridgeAddresses....
		// TODO: 

		// REGISTER MAC ADDRESSES from CHASSIS IDs
		if (this.Device.HasPortLldpTable) {
			var portLldpTable: PortLldpTable  = this.Device.PortLldpTable;

			if (portLldpTable.HasChassisId_MacAddress)
				this.Add(portLldpTable.ChassisId_MacAddress);
		}

		// REBUILD the CACHE if IfEntry objects
		this.RebuildIfEntryCache();
	}

	private RegisterIpAddressTable(ipTable: IpAddressTable):void {
		if (ipTable == null)
			return;

		ipTable.ForEach((ipEntry) => {
			if (!ipEntry.HasMacAddress)
				return;

			if (ipEntry.MacAddress.IsNull)
				return;

			this.AddIpEntry(ipEntry);
		});
	}

	private RegisterIfTable(ifTable: IfTable):void {
		if ((ifTable == null) || (ifTable.Count <= 0))
			return;

		ifTable.ForEach((ifEntry) => {
			if (!ifEntry.HasMacAddress)
				return;

			this.AddIfEntry(ifEntry);
		});
	}

	public Write(obj: any, context: any): void {
		// NOT SERIALIZED
		return;
	}

	public Read(obj: any, context: any): void {
		// NOT SERIALIZED
		return;
	}
}
